import clx from "classnames";
import React from "react";

interface Props {
    children: React.ReactNode;

    className?: string;
}

/**
 * We have this component because of various dropdowns that may be in this component
 * we always want to ensure that the actions will overlay the content.
 */
const CardActions = ({ children, className }: Props) => {
    const cn = clx("relative z-[2]", className);

    return <div className={cn}>{children}</div>;
};

export default CardActions;
